<template>
  <PodiumCard
    title="Podium réseau"
    emoji="🌐"
    badge-class="bg-blue-50"
    :ranking="organizationRanking.slice(0, 3)"
    :show-amount="false"
    :show-sales-channel="true"
  />
</template>

<script>
import PodiumCard from "./PodiumCard.vue";

export default {
  name: "organizationRanking",

  components: {
    PodiumCard,
  },

  props: {
    organizationRanking: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
